import BaseNotificationHandler from './baseHandler.js';

/**
 * Connection Request Notification Handler
 * Handles follow/connection request notifications
 */
class ConnectionRequestHandler extends BaseNotificationHandler {
  getIcon(notification, parsedData) {
    return "👥";
  }

  getMainText(notification, parsedData) {
    const senderName = this.getSenderInfo(notification, parsedData) || 'Someone';
    return `${senderName} sent you a connect request`;
  }

  handleClick(notification, parsedData, navigate, onClose) {
    const actionUrl = this.getActionUrl(notification, parsedData);
    const contentId = parsedData.content_id || notification.target_id;
    
    if (contentId) {
      navigate(`/social/profile/${contentId}`);
      if (onClose) onClose();
    } else if (actionUrl) {
      if (actionUrl.startsWith('http://') || actionUrl.startsWith('https://')) {
        window.location.href = actionUrl;
      } else {
        navigate(actionUrl);
      }
      if (onClose) onClose();
    }
  }

  /**
   * Connection requests have action buttons (Accept, Reject, View Profile)
   * @param {Object} notification - The notification object
   * @param {Object} parsedData - Parsed notification data
   * @returns {boolean} True
   */
  hasActionButtons(notification, parsedData) {
    return true;
  }
}

export default ConnectionRequestHandler;

